// Test IDs para el panel completo de administracion del agente de IA de
// WhatsApp (Configuracion, Base de conocimiento, Reglas, Probar,
// Conversaciones, Metricas).

export const AGENT_SETTINGS = {
  page: 'agent-settings-page',
  loadErrorBanner: 'agent-settings-load-error-banner',
  loadErrorRetryButton: 'agent-settings-load-error-retry-button',
  tabConfig: 'agent-settings-tab-config',
  tabKnowledge: 'agent-settings-tab-knowledge',
  tabRules: 'agent-settings-tab-rules',
  tabScheduling: 'agent-settings-tab-scheduling',
  tabPlayground: 'agent-settings-tab-playground',
  tabConversations: 'agent-settings-tab-conversations',
  tabMetrics: 'agent-settings-tab-metrics',
  tabTraining: 'agent-settings-tab-training', // Fix AO (2026-10-23)
  tabSms: 'agent-settings-tab-sms', // Fix AP (2026-10-23)

  // Configuracion
  activeToggle: 'agent-settings-active-toggle',
  assistantNameInput: 'agent-settings-assistant-name-input',
  webhookUrlField: 'agent-settings-webhook-url-field',
  copyWebhookButton: 'agent-settings-copy-webhook-button',
  toneInput: 'agent-settings-tone-input',
  systemPromptExtraInput: 'agent-settings-system-prompt-extra-input',
  languageEsCheckbox: 'agent-settings-language-es-checkbox',
  languageEnCheckbox: 'agent-settings-language-en-checkbox',
  welcomeMessageInput: 'agent-settings-welcome-message-input',
  escalationMessageInput: 'agent-settings-escalation-message-input',
  modelSelect: 'agent-settings-model-select',
  // Fix AJ (2026-10-23): motor de IA con cuenta propia de OpenAI
  llmSourceSelect: 'agent-settings-llm-source-select',
  openaiKeyInput: 'agent-settings-openai-key-input',
  openaiKeySavedNote: 'agent-settings-openai-key-saved-note',
  openaiKeyRemoveButton: 'agent-settings-openai-key-remove-button',
  openaiModelInput: 'agent-settings-openai-model-input',
  openaiTestButton: 'agent-settings-openai-test-button',
  openaiTestResult: 'agent-settings-openai-test-result',
  llmErrorBanner: 'agent-settings-llm-error-banner',
  // Fix AL (2026-10-23): derivacion a una asesora y etiquetado automatico
  advisorNameInput: 'agent-settings-advisor-name-input',
  advisorWhatsappInput: 'agent-settings-advisor-whatsapp-input',
  autoClassifyToggle: 'agent-settings-auto-classify-toggle',
  metricsAiUsage: 'agent-settings-metrics-ai-usage',
  playgroundLlmError: 'agent-settings-playground-llm-error',
  saveConfigButton: 'agent-settings-save-config-button',
  whatsappStatusCard: 'agent-settings-whatsapp-status-card',
  whatsappStatusBadge: 'agent-settings-whatsapp-status-badge',

  // Base de conocimiento: documentos
  documentsList: 'agent-settings-documents-list',
  documentsEmptyState: 'agent-settings-documents-empty-state',
  documentUploadInput: 'agent-settings-document-upload-input',
  documentUploadButton: 'agent-settings-document-upload-button',
  documentRowPrefix: 'agent-settings-document-row-',
  documentDeleteButtonPrefix: 'agent-settings-document-delete-button-',

  // Base de conocimiento: tratamientos
  knowledgeTable: 'agent-settings-knowledge-table',
  knowledgeRowPrefix: 'agent-settings-knowledge-row-',
  knowledgeEditButtonPrefix: 'agent-settings-knowledge-edit-button-',
  knowledgeModal: 'agent-settings-knowledge-modal',
  knowledgeWhatIsInput: 'agent-settings-knowledge-what-is-input',
  knowledgeAreasInput: 'agent-settings-knowledge-areas-input',
  knowledgeEffectDurationInput: 'agent-settings-knowledge-effect-duration-input',
  knowledgeContraindicationsInput: 'agent-settings-knowledge-contraindications-input',
  knowledgeAftercareInput: 'agent-settings-knowledge-aftercare-input',
  knowledgeBeforeCareInput: 'agent-settings-knowledge-before-care-input',
  knowledgeLengthPrefix: 'agent-settings-knowledge-length-',
  knowledgeExpectedResultsInput: 'agent-settings-knowledge-expected-results-input',
  knowledgeSessionsInput: 'agent-settings-knowledge-sessions-input',
  knowledgeTreatmentFaqsInput: 'agent-settings-knowledge-treatment-faqs-input',
  knowledgeSaveButton: 'agent-settings-knowledge-save-button',

  // Base de conocimiento: FAQs
  faqList: 'agent-settings-faq-list',
  faqRowPrefix: 'agent-settings-faq-row-',
  faqAddButton: 'agent-settings-faq-add-button',
  faqEditButtonPrefix: 'agent-settings-faq-edit-button-',
  faqDeleteButtonPrefix: 'agent-settings-faq-delete-button-',
  faqModal: 'agent-settings-faq-modal',
  faqQuestionInput: 'agent-settings-faq-question-input',
  faqAnswerInput: 'agent-settings-faq-answer-input',
  faqSaveButton: 'agent-settings-faq-save-button',
  faqEmptyState: 'agent-settings-faq-empty-state',

  // Reglas
  priceObjectionEsInput: 'agent-settings-price-objection-es-input',
  priceObjectionEnInput: 'agent-settings-price-objection-en-input',
  escalationKeywordsInput: 'agent-settings-escalation-keywords-input',
  escalationCasesInput: 'agent-settings-escalation-cases-input', // Fix AU (2026-10-27)
  escalationCasesCount: 'agent-settings-escalation-cases-count',
  saveRulesButton: 'agent-settings-save-rules-button',

  // Probar (playground)
  playgroundMessages: 'agent-settings-playground-messages',
  playgroundInput: 'agent-settings-playground-input',
  playgroundSendButton: 'agent-settings-playground-send-button',
  playgroundResetButton: 'agent-settings-playground-reset-button',
  playgroundBubblePrefix: 'agent-settings-playground-bubble-',
  playgroundEscalatedNotice: 'agent-settings-playground-escalated-notice',

  // Metricas
  metricsPeriodSelector: 'agent-settings-metrics-period-selector',
  metricsTotalConversations: 'agent-settings-metrics-total-conversations',
  metricsNewLeads: 'agent-settings-metrics-new-leads',
  metricsEscalated: 'agent-settings-metrics-escalated',
  metricsTopLanguage: 'agent-settings-metrics-top-language',
  metricsLanguageBreakdown: 'agent-settings-metrics-language-breakdown',
  metricsAppointmentsBooked: 'agent-settings-metrics-appointments-booked',
  metricsConversionRate: 'agent-settings-metrics-conversion-rate',

  // Agendamiento
  schedulingEnabledToggle: 'agent-settings-scheduling-enabled-toggle',
  bookingLinkToggle: 'agent-settings-booking-link-toggle', // Fix AM (2026-10-23)
  schedulingServiceRowPrefix: 'agent-settings-scheduling-service-row-',
  schedulingServiceHumanCheckboxPrefix: 'agent-settings-scheduling-service-human-checkbox-',
  schedulingDepositToggle: 'agent-settings-scheduling-deposit-toggle',
  schedulingDepositTypeSelect: 'agent-settings-scheduling-deposit-type-select',
  schedulingDepositValueInput: 'agent-settings-scheduling-deposit-value-input',
  schedulingLeadMinutesInput: 'agent-settings-scheduling-lead-minutes-input',
  schedulingSlotOptionsInput: 'agent-settings-scheduling-slot-options-input',
  saveSchedulingButton: 'agent-settings-save-scheduling-button',
};

// Fix AP (2026-10-23): Agente IA > SMS
export const AGENT_SMS = {
  tab: 'agent-sms-tab',
  error: 'agent-sms-error',
  statusBadge: 'agent-sms-status-badge',
  enabledToggle: 'agent-sms-enabled-toggle',
  sidInput: 'agent-sms-sid-input',
  tokenInput: 'agent-sms-token-input',
  fromInput: 'agent-sms-from-input',
  serviceInput: 'agent-sms-service-input',
  saveButton: 'agent-sms-save-button',
  testButton: 'agent-sms-test-button',
  testResult: 'agent-sms-test-result',
  webhookUrl: 'agent-sms-webhook-url',
  webhookEmpty: 'agent-sms-webhook-empty',
  copyButton: 'agent-sms-copy-button',
  agentToggle: 'agent-sms-agent-toggle',
  checklist: 'agent-sms-checklist',
};

// Fix AO (2026-10-23): Agente IA > Entrenamiento
export const AGENT_TRAINING = {
  tab: 'agent-training-tab',
  enabledToggle: 'agent-training-enabled-toggle',
  counts: 'agent-training-counts',
  newButton: 'agent-training-new-button',
  ratingFilter: 'agent-training-rating-filter',
  sourceFilter: 'agent-training-source-filter',
  empty: 'agent-training-empty',
  rowPrefix: 'agent-training-row-', // + id
  activeTogglePrefix: 'agent-training-active-toggle-', // + id
  editPrefix: 'agent-training-edit-', // + id
  deletePrefix: 'agent-training-delete-', // + id
  deleteConfirm: 'agent-training-delete-confirm',
  dialog: 'agent-training-dialog',
  ratingSelect: 'agent-training-rating-select',
  leadInput: 'agent-training-lead-input',
  replyInput: 'agent-training-reply-input',
  commentInput: 'agent-training-comment-input',
  correctionInput: 'agent-training-correction-input',
  saveButton: 'agent-training-save-button',
};
